function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}
export function dueState(dueAt, completedAt, now = new Date()) {
    if (completedAt)
        return 'done';
    if (!dueAt)
        return 'none';
    const due = dueAt instanceof Date ? dueAt : new Date(dueAt);
    if (Number.isNaN(due.getTime()))
        return 'none';
    if (due.getTime() < now.getTime())
        return 'overdue';
    const dayDiff = Math.round((startOfDay(due) - startOfDay(now)) / 86_400_000);
    if (dayDiff <= 0)
        return 'today';
    if (dayDiff === 1)
        return 'tomorrow';
    return 'later';
}
/** ISO-Woche: Montag ist der erste Wochentag (SPEC 16). */
export function startOfIsoWeek(date) {
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const weekday = (result.getDay() + 6) % 7;
    result.setDate(result.getDate() - weekday);
    return result;
}
export function isWithinCurrentIsoWeek(date, now = new Date()) {
    const weekStart = startOfIsoWeek(now).getTime();
    const weekEnd = weekStart + 7 * 86_400_000;
    const time = startOfDay(date);
    return time >= weekStart && time < weekEnd;
}
/**
 * „Heute, ganztaegig" als Default-Faelligkeit beim Anlegen ohne eigene
 * Angabe (SPEC 9.1). Dasselbe Sentinel-Muster wie beim manuellen Setzen ohne
 * Uhrzeit im Formular: 23:59 Ortszeit, `dueHasTime: false`. Ueber lokale
 * Datumsteile statt Millisekunden-Arithmetik — sonst verschoebe eine
 * Zeitumstellung das Ergebnis um eine Stunde (siehe Wiederholungsregeln).
 */
export function startOfTodayEndOfDay(now = new Date()) {
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59);
}
//# sourceMappingURL=date.js.map